export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_VIDEO_AND_PHOTOGRAPHY.6b594a00.svg";